<template>
    <div class="page-header-container">
<!--        <notifier />-->
<!--        <select-lang />-->
<!--        <a-divider style="margin: 0 24px;background-color: rgba(52, 81, 148, 0.3)" type="vertical" />-->
        <span class="account-avatar" v-if="$store.state.user.info.username">
            <a-avatar :src="userIcon" />
        <span class="username" :style="this.$route.fullPath.indexOf('BestYou/nomination/nomination') > 0 ? {'color':'#0F307A'} : {}">{{ $store.state.user.info.birthName }}</span>
    </span>
        <span class="account-avatar" v-else>
        <a-spin />
    </span>
        <!-- <delegation-dropdown
            :menu="showMenu"
            :current-user="$store.state.user.info.username"
            @refeshUser="handleChangeUser"
            @fullLoading="fullLoading"
        /> -->
    </div>
</template>

<script>
import Notifier from '../Notifier';
import SelectLang from '../LangSelector';
import DelegationDropdown from '../Delegation';
import { count } from '@/api/system/notification';

export default {
    name: 'right-content',
    components: {
        DelegationDropdown,
        Notifier,
        SelectLang
    },
    data() {
        return {
            showMenu: true,
            currentUser: this.$store.state.user.info.nickname,
            userIcon: require('@/assets/img/avatar.png')
        };
    },
    methods: {
        handleChangeUser() {
            this.$store.dispatch('user/getInfo', { param: this.uid }).then(() => {
                this.$store.dispatch('menu/initMenus').then(() => {
                    this.pathTo();
                });
            });
            this.$emit('fullLoading', 1);
            // console.log('delegator', this.$store.state.user.info.delegator);
        },
        fullLoading(ty) {
            this.$emit('fullLoading', ty);
        },
        pathTo() {
            const isExitPath = this.filterPath();
            if (isExitPath) {
                this.$router.push({ path: this.$route.path });
            } else {
                const menus = this.$store.state.menu.menus;
                const oneM = menus[1].children[0];
                if (oneM.children && oneM.children.length) {
                    this.$router.push({ path: oneM.children[0].path });
                } else {
                    this.$router.push({ path: oneM.path });
                }
            }
            // this.getCount()
        },
        filterPath() {
            const path = this.$route.path;
            const menus = this.$store.state.menu.menus;
            let isPath = false;
            menus.forEach((element) => {
                if (element.path == path) {
                    isPath = true;
                } else {
                    if (element.children && element.children.length) {
                        element.children.forEach((subItem) => {
                            if (subItem.path == path) {
                                isPath = true;
                            }
                        });
                    }
                }
            });
            return isPath;
        },
        getCount() {
            count().then((res) => {
                this.notificationCount = res;
                // console.log('count',res)
            });
        }
    }
};
</script>
<style lang="less" scoped>
@import (reference) '~@/assets/styles/variables.less';

.page-header-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    margin-left: auto;
    padding-right: 50px;

    /deep/ .ant-divider,
    /deep/ .ant-divider-vertical {
        top: 0;
    }
}
.account-avatar {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .username {
        margin-left: 8px;
        // color: white;
        color: #0F307A;
        //color: @logoColor;
        font-size: 12px;
        line-height: 20px;
    }
    /deep/ .ant-avatar {
        color: @g20;
        line-height: 30px;
        background-color: transparent;
        border: solid 1px @g20;
    }
    /deep/ .ant-spin {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>

